import {SystemMemoryProps} from "../../../models/SystemMemoryProps";
import {Space} from "@mantine/core";
import {ApiDataHelper} from "../../../data/ApiDataHelper";
import {TableEditor} from "../../TableEditor";
import {IconCalendar, IconFileDescription, IconHash, IconId, IconSignature} from "@tabler/icons-react";
import {CommissionsStatusesModel} from "../../../models/admin/commissions/CommissionsStatusModel";

export function AdminCommissionsStatuses(memory: SystemMemoryProps) {
    return (
        <>
            <Space h="lg"/>
            {TableEditor<CommissionsStatusesModel>({
                headers: [
                    {title: 'ID', key: 'id', type: 'text', viewOnly: true, icon: <IconId size="0.8rem"/>},
                    {title: 'Name', key: 'name', type: 'text', viewOnly: false, icon: <IconSignature size="0.8rem"/>},
                    {title: 'Description', key: 'description', type: 'rich', viewOnly: false, icon: <IconFileDescription size="0.8rem"/>},
                    {title: 'Colour Code', key: 'colour', type: 'colour', viewOnly: false, icon: <IconHash size="0.8rem"/>},
                    {title: 'Created', key: 'created', type: 'text', viewOnly: true, icon: <IconCalendar size="0.8rem"/>}
                ],
                apiObject: new ApiDataHelper(memory),
                getURL: '/v1/admin/commissions/statuses',
                postURL: {url: '/v1/admin/commissions/statuses/insert', keys: ['name', 'description', 'colour']},
                putURL: {url: '/v1/admin/commissions/statuses/update', keys: ['name', 'description', 'colour']},
                delURL: '/v1/admin/commissions/statuses/delete'
            })}
        </>
    );
}